import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col,Popover} from 'antd';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;


class Top10SeriesTrailerCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}
	
	async componentDidUpdate(prevProps) {
	}



	render() {
		const { opensearchTop10SeriesTrailerList, opensearchSeriesList } = this.props;
		cc_data = opensearchTop10SeriesTrailerList || [];
		cc_data = cc_data.sort((a, b) => b.doc_count - a.doc_count);
		
		
		let contentlist = opensearchSeriesList || [];
		let tvseries,tvseason = '';
		let poster = require('../../../src/static/no_image.jpg');
		
		function getPoster(contentId){
			tvseries = contentlist.find(d=> d._source.metadata[0].title === contentId && d._source.contentType === 'tvseries');
			if(tvseries && tvseries._source && tvseries._source.contentId){
				tvseason = contentlist.find(d=> d._source.tvseriesId === tvseries._source.contentId && d._source.contentType === 'tvseasons');
			}
			if(tvseason && tvseason._source && tvseason._source.imageLandscape){
				poster =  tvseason._source.imageLandscape;
			}	
			return poster;
		};
		
		  const settings = {
			focusOnSelect: true,
			infinite: false,
			variableWidth: true,
			slidesToScroll: 1,
			speed: 500,
		  };

		return (
			<Card className="analyticCard portraitPoster">
				<h3 className="title">{`Top 10 Series Trailers  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='Top10SeriesTrailerCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map((c,k) => ({ items: k+1 , content_title: c.key , count:c.doc_count}))} target="_blank" filename={"Top 10 Series Trailers.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
					<Col span={24}>
						<Slider   {...settings}>
							{
								cc_data.map((d, k) =>(
									<div key= 'poster' className='portaitPoster'>
										<div key='image' className='portaitPoster image'><img alt="" src={getPoster(d.key)}  style={{width:'100%' }}></img></div>
										<div key='title' className='portaitPoster detail'><p className="portaitPoster title">#{k+1}  {d.key}</p></div>
										<div key='views' className='portaitPoster detail'><p className="portaitPoster view">{d.doc_count} views</p></div>
									</div>
									)
									
								)
							}
						
						</Slider>
						{/* <ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{ color: "#74add1" }} /> */}
					</Col>
				</Row>
			</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	opensearchTop10SeriesTrailerList: state.recommendation.opensearchTop10SeriesTrailerList,
	selectedOrganization: state.user.selectedOrganization,
	opensearchSeriesList : state.analytics.opensearchSeriesList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Top10SeriesTrailerCard));
